import { render } from "./EstateActions.vue?vue&type=template&id=445a2f6c&scoped=true"
import script from "./EstateActions.vue?vue&type=script&lang=js"
export * from "./EstateActions.vue?vue&type=script&lang=js"

import "./EstateActions.vue?vue&type=style&index=0&id=445a2f6c&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-445a2f6c"]])

export default __exports__